// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pj_a bhg_ea bhg_kb bhg_js bhg_a bhg_j bhg_sm bhg_sn","SearchPanel__icon":"pj_b bhg_vm bhg_hg bhg_ss bhg_uy","SearchPanel__input":"pj_c bhg_iz bhg_eb bhg_z"};